<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  data() {
	return {
		
	}  
  },
  methods:{
	  
  },
  mounted() {//created
  	if(typeof this.$user !=="undefined" && this.$user.login()) {//已登录
		this.$user.refresh();//刷新用户信息
        this.$company.refresh();//刷新公司信息
        this.$company.refreshWarehouseList();//刷新苗圃信息
	}
  }
}
</script>

<style>
  @import 'style/common.scss';
  * {
    padding: 0;
    margin: 0;
  }
  html,
  body { height: 100%; padding: 0; margin: 0; }
#app {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue